import PropTypes from 'prop-types';
import React from 'react';

import Animate from '../animate';

import './index.scss';

const SubIntro = props => {
    const {
        children,
        leftAligned,
    } = props;

    const className = leftAligned ? 'sub-intro-holder left-aligned' : 'sub-intro-holder';

    return (
        <Animate>
            <div className={className}>
                {children}
            </div>
        </Animate>
    );
};

SubIntro.propTypes = {
    children: PropTypes.any,
    leftAligned: PropTypes.bool,
};

export default SubIntro;
